import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import { createPinia } from "pinia";

//import { StorePresist } from '@/store/useStore';

let pinia = createPinia();

//pinia.use(StorePresist);

createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(pinia)
  .use(router)
  .mount("#app");
